module.exports = __webpack_public_path__ + "img/homepage_1--mobile@3x.e3dce799.jpg";